import React, { useState } from "react";

// react-bootstrap components
import {
  Button,
  Card,
  Col,
  Container,
  Form,
  InputGroup,
  Modal,
  Nav,
  Row,
} from "react-bootstrap";

import Drawer from "react-modern-drawer";

// core components
import ReactTable from "components/ReactTable/ReactTable.js";
import { Query, useMutation, useQuery } from "react-apollo";
import { GET_APP_USERS, GET_CLIENT } from "./queries";

import map from "lodash/map";
import compact from "lodash/compact";
import last from "lodash/last";
import includes from "lodash/includes";
import withSession from "./withSession";
import toLower from "lodash/toLower";
import filter from "lodash/filter";
import find from "lodash/find";
import cloneDeep from "lodash/cloneDeep";
import unset from "lodash/unset";
import {
  ADD_APP_USER,
  ADD_UNOFFICAL_TEAM_MEMBER,
  CANCEL_USER,
  CHANGE_APP_USER_PASSWORD,
  DELETE_APP_USER,
  DELETE_APP_USER_SUBSCRIPTION,
  REMOVE_TEAM_MEMBER,
  UPDATE_APP_USER,
} from "./mutations";
import { Eye, EyeSlash } from "react-bootstrap-icons";
import { CSVLink } from "react-csv";
import DatePicker from "react-datepicker";
import BlockUi from "react-block-ui";
import "react-block-ui/style.css";
import Messages from "./Messages";

function BulkFooter({ table }) {
  // const selectedUsers = table.getFilteredSelectedRowModel()
  const selectedUsers = table.getSelectedRowModel()?.rows;
  const [openMessage, setOpenMessage] = useState(false);
  return (
    <Row
      style={{
        display:
          table.getIsSomeRowsSelected() || table.getIsAllRowsSelected()
            ? "inherit"
            : "none",
      }}
    >
      <Col md="6" style={{ fontSize: "13px" }}>
        <h4 className="title">{selectedUsers?.length} users selected</h4>
      </Col>
      <Col md="6">
        <Messages selected={selectedUsers} />
      </Col>
    </Row>
  );
}

function AppUsers(props) {
  const [modal, setModal] = React.useState(false);
  const [deleteModal, setDeleteModal] = React.useState(false);
  const [cancelModal, setCancelModal] = React.useState(false);
  const [modalPassword, setModalPassword] = React.useState(false);

  const [loader, setLoader] = React.useState(false);

  const [firstName, setFirstName] = React.useState("");
  const [lastName, setLastName] = React.useState("");
  const [userId, setUserId] = React.useState("");
  const [email, setEmail] = React.useState("");
  const [status, setStatus] = React.useState("Active");
  const [active, setActive] = React.useState(true);
  const [challengeId, setChallengeId] = React.useState("");
  const [courseId, setCourseId] = React.useState("");
  const [teamLeaderId, setTeamLeaderId] = React.useState("");
  const [gifts, setGifts] = React.useState(6);
  const [password, setPassword] = React.useState("");
  const [needPasswordReset, setNeedPasswordReset] = React.useState(true);
  const [oldPassword, setOldPassword] = React.useState("");
  const [confirmPassword, setConfirmPassword] = React.useState("");
  const [supportPasswordEnabled, setSupportPasswordEnabled] =
    React.useState(false);

  const [expirationDate, setExpirationDate] = React.useState(null);

  const [isCoach, setIsCoach] = React.useState(false);

  const [showSubscriptionFields, setShowSubscriptionFields] =
    React.useState(true);

  const [passwordMask, setPasswordMask] = React.useState(true);
  const [passwordMaskOld, setPasswordMaskOld] = React.useState(true);
  const [passwordMaskConfirm, setPasswordMaskConfirm] = React.useState(true);
  const [showError, setShowError] = React.useState("");
  const [showErrorConfirm, setShowErrorConfirm] = React.useState("");

  const [editEmail, setEditEmail] = React.useState("");
  const [editChallengeId, setEditChallengeId] = React.useState("");
  const [editCourseId, setEditCourseId] = React.useState("");
  const [editTeamLeaderId, setEditTeamLeaderId] = React.useState("");

  const defaultTab = {
    name: "All",
    filter: (user) => {
      return true;
    },
  };
  const [selectedTab, setSelectedTab] = React.useState(defaultTab);
  const [selectedLeaderId, setSelectedLeaderId] = React.useState(null);
  const [selectedUserId, setSelectedUserId] = React.useState("");
  const [selectedUsers, setSelectedUsers] = React.useState([]);

  const { loading, data, error } = useQuery(GET_CLIENT, {
    variables: { name: props?.session?.me?.clientName },
  });

  const { getClient } = data || {};
  const { challenges, courses } = getClient || {};

  const togglePasswordVisibility = () => {
    setPasswordMask(!passwordMask);
  };

  const togglePasswordVisibilityOld = () => {
    setPasswordMaskOld(!passwordMaskOld);
  };

  const togglePasswordVisibilityConfirm = () => {
    setPasswordMaskConfirm(!passwordMaskConfirm);
  };

  const handleActiveChange = (event) => {
    if (event.target.value === "yes") setActive(true);
    else setActive(false);
    // Additional logic on selection change can be added here
  };

  const handleChallengeChange = (event) => {
    setChallengeId(event.target.value);
  };

  const handleCourseChange = (event) => {
    setCourseId(event.target.value);
  };

  const [addAppUser] = useMutation(ADD_APP_USER);
  const [updateAppUser] = useMutation(UPDATE_APP_USER);
  const [changeAppUserPassword] = useMutation(CHANGE_APP_USER_PASSWORD);
  const [deleteAppUser] = useMutation(DELETE_APP_USER);
  const [deleteAppUserSubscription] = useMutation(DELETE_APP_USER_SUBSCRIPTION);
  const [addUnofficalTeamMember] = useMutation(ADD_UNOFFICAL_TEAM_MEMBER);
  const [removeTeamMember] = useMutation(REMOVE_TEAM_MEMBER);
  const [cancelUser] = useMutation(CANCEL_USER);

  const handleOpenEdit = (user) => {
    setModal(true);
    setUserId(user._id);
    setFirstName(user.firstname);
    setLastName(user.lastname);
    setEmail(user.email);
    setStatus(user.status);
    setActive(user.active || false);
    setChallengeId(user?.activeChallenge?.challengeId);
    setEditChallengeId(user?.activeChallenge?.challengeId);
    setCourseId(user?.activeCourseId);
    setEditCourseId(user?.activeCourseId);
    setTeamLeaderId(user?.teamLeader?._id);
    setEditTeamLeaderId(user?.teamLeader?._id);
    setExpirationDate(
      user?.subscription?.endDate ? new Date(user?.subscription?.endDate) : null
    );
    setEditEmail(user.email);
    setIsCoach(user.isCoach);
    setSupportPasswordEnabled(user.supportPasswordEnabled);
    setShowError("");
    setShowSubscriptionFields(
      !user?.subscription || user?.subscription?.appType === "external"
    );
    setGifts(
      user?.subscription?.teamLimit ? user?.subscription?.teamLimit + 1 : 6
    );
  };

  const handleOpenDelete = (user) => {
    setDeleteModal(true);
    setUserId(user._id);
  };

  const handleCloseDelete = (user) => {
    setDeleteModal(false);
    setUserId("");
  };

  const handleOpenCancel = () => {
    setCancelModal(true);
  };

  const handleCloseCancel = () => {
    setCancelModal(false);
  };

  const handleClose = () => {
    setModal(false);
    setFirstName("");
    setLastName("");
    setEmail("");
    setStatus("Active");
    setActive(true);
    setChallengeId("");
    setEditChallengeId("");
    setCourseId("");
    setEditCourseId("");
    setTeamLeaderId("");
    setEditTeamLeaderId("");
    setPassword("");
    setPasswordMask(true);
    setEditEmail("");
    setIsCoach(false);
    setSupportPasswordEnabled(false);
    setExpirationDate(null);
    setShowSubscriptionFields(true);
    setGifts(6);
  };

  const handleOpenPassword = () => {
    setModalPassword(true);
    setOldPassword("");
    setPassword("");
    setConfirmPassword("");
    setShowError("");
    setShowErrorConfirm("");
  };

  const handleClosePassword = () => {
    setModalPassword(false);
    setOldPassword("");
    setPassword("");
    setConfirmPassword("");
    setShowError("");
    setPasswordMask(true);
    setPasswordMaskOld(true);
    setPasswordMaskConfirm(true);
    setNeedPasswordReset(true);
  };

  const getChallengeInput = () => {
    if (challengeId === editChallengeId) return undefined;
    else if (!challengeId) return null;
    else {
      let challenge = find(challenges, (challenge) => {
        return challenge._id === challengeId;
      });
      let newChallenge = cloneDeep(challenge);
      newChallenge.startDate = new Date();
      newChallenge.challengeId = newChallenge._id;
      unset(newChallenge, "_id");
      unset(newChallenge, "__typename");
      let adjustedWelcome = newChallenge?.welcomeItem;
      unset(adjustedWelcome, "_id");
      unset(adjustedWelcome, "__typename");
      map(adjustedWelcome?.habits, (habit) => {
        unset(habit, "_id");
        unset(habit, "__typename");
      });
      map(adjustedWelcome?.tasks, (task) => {
        unset(task, "__typename");
      });
      let adjustedEnding = newChallenge?.endingItem;
      unset(adjustedEnding, "_id");
      unset(adjustedEnding, "__typename");
      newChallenge.welcomeItem = adjustedWelcome;
      newChallenge.endingItem = adjustedEnding;

      map(newChallenge?.schedule, (item) => {
        unset(item, "__typename");
        map(item?.notifications, (notification) => {
          unset(notification, "__typename");
          unset(notification, "_id");
        });
        map(item?.tasks, (task) => {
          unset(task, "__typename");
        });
        map(item?.habits, (habit) => {
          unset(habit, "__typename");
          unset(habit, "_id");
        });
      });
      return newChallenge;
    }
  };

  const handleAddUser = () => {
    addAppUser({
      variables: {
        email,
        firstname: firstName,
        lastname: lastName,
        status: "Admin Added",
        password,
        active,
        expirationDate,
        isCoach,
        supportPasswordEnabled,
        app: toLower(props.session.me.clientName),
        // activeChallenge: getChallengeInput(),
        gifts: Number(gifts),
      },
      refetchQueries: [
        {
          query: GET_APP_USERS,
          variables: {
            name: props.session.me.clientName,
          },
        },
      ],
    })
      .then(() => {
        handleClose();
      })
      .catch((error) => {
        setShowError(error.message);
      });
  };

  const handleEditUser = () => {
    updateAppUser({
      variables: {
        oldEmail: editEmail,
        userInput: {
          firstname: firstName,
          lastname: lastName,
          email,
          active,
          isCoach,
          supportPasswordEnabled,
          activeChallenge: getChallengeInput(),
          activeCourse: courseId,
        },
        expirationDate,
        teamLeaderId:
          teamLeaderId === editTeamLeaderId
            ? undefined
            : !teamLeaderId
            ? null
            : teamLeaderId,
        gifts: Number(gifts),
      },
      refetchQueries: [
        {
          query: GET_APP_USERS,
          variables: {
            name: props.session.me.clientName,
          },
        },
      ],
    })
      .then(() => {
        handleClose();
      })
      .catch((error) => {
        setShowError(error.message);
      });
  };

  const handleChangePassword = () => {
    if (password !== confirmPassword) {
      setShowErrorConfirm("Does not match password");
      return;
    }
    changeAppUserPassword({
      variables: {
        userId: userId,
        password,
        needPasswordReset,
      },
      refetchQueries: [
        {
          query: GET_APP_USERS,
          variables: {
            name: props.session.me.clientName,
          },
        },
      ],
    })
      .then(() => {
        handleClosePassword();
      })
      .catch((error) => {
        setShowError(error.message);
      });
  };

  const handleDeleteUser = () => {
    deleteAppUser({
      variables: {
        userId: userId,
      },
      refetchQueries: [
        {
          query: GET_APP_USERS,
          variables: {
            name: props.session.me.clientName,
          },
        },
      ],
    })
      .then(() => {
        deleteAppUserSubscription({
          variables: {
            userId: userId,
          },
          refetchQueries: [
            {
              query: GET_APP_USERS,
              variables: {
                name: props.session.me.clientName,
              },
            },
          ],
        })
          .then(() => {
            handleCloseDelete();
          })
          .catch((error) => {
            ShowError(error.message);
          });
      })
      .catch((error) => {
        setShowError(error.message);
      });
  };

  const handleCancelSubscription = () => {
    deleteAppUserSubscription({
      variables: {
        userId: userId,
      },
      refetchQueries: [
        {
          query: GET_APP_USERS,
          variables: {
            name: props.session.me.clientName,
          },
        },
      ],
    })
      .then(() => {
        handleCloseCancel();
        // handleClose();
      })
      .catch((error) => {
        setShowError(error.message);
      });
  };

  const handleAddPaidUser = () => {
    setLoader(true);
    addUnofficalTeamMember({
      variables: {
        leaderId: selectedLeaderId,
        userId: selectedUserId,
      },
      awaitRefetchQueries: true,
      refetchQueries: [
        {
          query: GET_APP_USERS,
          variables: {
            name: props.session.me.clientName,
          },
        },
      ],
    }).finally(() => {
      setLoader(false);
    });
  };

  const handleRemovePaidUser = (userId) => {
    setLoader(true);
    removeTeamMember({
      variables: {
        userId: userId,
      },
      awaitRefetchQueries: true,
      refetchQueries: [
        {
          query: GET_APP_USERS,
          variables: {
            name: props.session.me.clientName,
          },
        },
      ],
    }).finally(() => {
      setLoader(false);
    });
  };

  const tableColumns = [
    {
      id: "select-col",
      header: ({ table }) => {
        return (
          <>
            <Form.Check>
              <Form.Check.Label>
                <Form.Check.Input
                  checked={table.getIsAllRowsSelected()}
                  indeterminate={table.getIsSomeRowsSelected()}
                  type="checkbox"
                  onChange={table.getToggleAllRowsSelectedHandler()}
                />
                <span className="form-check-sign"></span>
              </Form.Check.Label>
            </Form.Check>
          </>
        );
      },
      cell: ({ row }) => {
        return (
          <Form.Check>
            <Form.Check.Label>
              <Form.Check.Input
                checked={row.getIsSelected()}
                disabled={!row.getCanSelect()}
                type="checkbox"
                onChange={row.getToggleSelectedHandler()}
              />
              <span className="form-check-sign"></span>
            </Form.Check.Label>
          </Form.Check>
        );
      },
      enableSorting: false,
    },
    {
      header: "Name",
      accessorKey: "name",
    },
    {
      header: "Email",
      accessorKey: "email",
    },
    {
      header: "Created",
      accessorKey: "createdAt",
    },
    {
      header: "Active",
      accessorKey: "active",
      cell: (props) => <span>{props.getValue() ? "Yes" : "No"}</span>,
    },
    // Conditionally add last rewire and last login if ultimind
    ...(props.session.me.clientName === "Ultimind"
      ? [
          {
            header: "Last Rewire",
            accessorKey: "rewireChatDates",
          },
          {
            header: "Last Login",
            accessorKey: "dailyStreakDate",
          },
        ]
      : []),
    {
      header: "Challenge",
      accessorKey: "activeChallenge.title",
    },
    // Conditionally add the "Gifts" column based on `app` being true
    ...(props.session.me.clientName === "feelwise" ||
    props.session.me.clientName === "regulate" ||
    props.session.me.clientName === "lumify"
      ? [
          {
            header: "Team Leader",
            accessorKey: "teamLeader",
          },
        ]
      : []),
    ...(props.session.me.clientName === "feelwise" ||
    props.session.me.clientName === "regulate" ||
    props.session.me.clientName === "lumify"
      ? [
          {
            header: "Type",
            accessorKey: "type",
          },
        ]
      : []),
    {
      header: "Actions",
      accessorKey: "actions",
      enableSorting: false,
      enableColumnFilter: false,
      skipCSVDownload: true,
      cell: ({ row }) => {
        const user = row.original;
        return (
          // we've added some custom button actions
          <div className="actions-right">
            {/* use this button to add a edit kind of action */}
            {/* <Button
              variant="info"
              size="sm"
              className="text-info btn-link edit"
              onClick={() => handleOpenEdit(user)}
            >
              <i className="fa fa-info" />
            </Button>{" "} */}
            <Button
              variant="warning"
              size="sm"
              className="text-warning btn-link edit"
              onClick={() => handleOpenEdit(user)}
            >
              <i className="fa fa-edit" />
            </Button>{" "}
            <Button
              variant="danger"
              size="sm"
              className="text-danger btn-link edit"
              onClick={() => handleOpenDelete(user)}
            >
              <i className="fa fa-trash" />
            </Button>{" "}
            {selectedTab?.name === "Coaches" && (
              <Button
                variant="info"
                size="sm"
                className="text-info btn-link edit"
                onClick={() => setSelectedLeaderId(user._id)}
              >
                <i className="fa fa-user" />
              </Button>
            )}
            {/* use this button to remove the data row */}
            {/* <Button
              onClick={() => {
                var newData = data;
                newData.find((o, i) => {
                  if (o.id === key) {
                    newData.splice(i, 1);
                    return true;
                  }
                  return false;
                });
                setData([...newData]);
              }}
              variant="danger"
              size="sm"
              className="btn-link remove text-danger"
            >
              <i className="fa fa-times" />
            </Button>{" "} */}
          </div>
        );
      },
    },
  ];

  const groupTableColumns = [
    {
      header: "Name",
      accessorKey: "name",
    },
    {
      header: "Email",
      accessorKey: "email",
    },
    {
      header: "Invited By",
      accessorKey: "referredBy",
    },
    {
      header: "Paid/Invited",
      accessorKey: "isPaid",
    },
    {
      header: "Actions",
      accessorKey: "actions",
      enableSorting: false,
      enableColumnFilter: false,
      skipCSVDownload: true,
      cell: ({ row }) => {
        const user = row.original;
        return (
          // we've added some custom button actions
          <div className="actions-right">
            {/* use this button to add a edit kind of action */}
            {/* <Button
                  variant="info"
                  size="sm"
                  className="text-info btn-link edit"
                  onClick={() => handleOpenEdit(user)}
                >
                  <i className="fa fa-info" />
                </Button>{" "} */}
            <Button
              variant="danger"
              size="sm"
              className="text-danger btn-link edit"
              onClick={() => handleRemovePaidUser(user._id)}
            >
              <i className="fa fa-trash" />
            </Button>
          </div>
        );
      },
    },
  ];

  const tabs =
    props.session.me.clientName === "lumify"
      ? [
          {
            name: "Coaches",
            filter: (user) => {
              return user.isCoach;
            },
          },
          {
            name: "Invited",
            filter: (user) => {
              return user.isSubscribed && user.teamLeaderId !== user._id;
            },
          },
          {
            name: "Free",
            filter: (user) => {
              return !user.isSubscribed;
            },
          },
          {
            name: "Paid Users",
            filter: (user) => {
              return (
                user.isSubscribed &&
                user.teamLeaderId === user._id &&
                !user.isCoach
              );
            },
          },
        ]
      : [];

  return (
    <Query
      query={GET_APP_USERS}
      variables={{
        name: props.session.me.clientName,
      }}
    >
      {({ loading, data, refetch }) => {
        if (loading) return "Loading...";
        const selectedLeader = find(data.getAppUsers, (user) => {
          return user._id === selectedLeaderId;
        });
        const selectedGroup = filter(data.getAppUsers, (user) => {
          return includes(
            map(selectedLeader?.teamMembers, (member) => member._id),
            user._id
          );
        });
        const selectedGroupData = map(selectedGroup, (user, key) => {
          return {
            id: key,
            ...user,
            name: user.firstname
              ? `${user.firstname} ${user.lastname ? user.lastname : ""}`
              : "",
            isPaid: user.isCoach
              ? "Coach"
              : user.teamLeader?._id === user._id && user.isSubscribed
              ? "Paid"
              : "Invited",
            referredBy: user.referredBy?.firstname
              ? `${user.referredBy.firstname} ${
                  user.referredBy?.lastname ? user.referredBy.lastname : ""
                }`
              : user.referredBy?.email
              ? user.referredBy.email
              : "",
          };
        });
        const tableData = map(data.getAppUsers, (user, key) => {
          // const formatedSubscriptions = map(user.subscriptions, (sub) => {
          //   const { appType = "", product_id = "" } = sub || {};
          //   const type = appType ? appType : "Internal Account";
          //   const period = includes(product_id, "monthly")
          //     ? "Monthly"
          //     : includes(product_id, "yearly")
          //     ? "Yearly"
          //     : "Unknown";
          //   return {
          //     ...sub,
          //     start_date: !sub.start_date
          //       ? ""
          //       : new Date(sub.start_date).toLocaleDateString(),
          //     end_date: !sub.end_date
          //       ? ""
          //       : new Date(sub.end_date).toLocaleDateString(),
          //     appType: `${type} - ${period}`,
          //   };
          // });
          const { subscription = {} } = user;
          const { appType = "", product_id = "" } = subscription || {};
          const type = appType ? appType : "Internal Account";
          const period = includes(product_id, "monthly")
            ? "Monthly"
            : includes(product_id, "yearly")
            ? "Yearly"
            : "Unknown";
          let formatedSubscription = {
            ...subscription,
            start_date: !subscription?.start_date
              ? ""
              : new Date(subscription?.start_date).toLocaleDateString(),
            end_date: !subscription?.end_date
              ? ""
              : new Date(subscription?.end_date).toLocaleDateString(),
            appType: `${type} - ${period}`,
          };
          return {
            id: key,
            ...user,
            name: user.firstname
              ? `${user.firstname} ${user.lastname ? user.lastname : ""}`
              : "",
            // active: user.active ? "Yes" : "No",
            subscription: formatedSubscription,
            // subscriptions: formatedSubscriptions,
            createdAt: !user.createdAt
              ? ""
              : new Date(user.createdAt).toLocaleDateString(),
            rewireChatDates: !last(user.rewireChatDates)?.date
              ? ""
              : new Date(last(user.rewireChatDates).date).toLocaleDateString(),
            dailyStreakDate: !user.dailyStreakDate
              ? ""
              : new Date(user.dailyStreakDate).toLocaleDateString(),
            teamLeader: user.teamLeader?.firstname
              ? `${user.teamLeader.firstname} ${
                  user.teamLeader?.lastname ? user.teamLeader.lastname : ""
                }`
              : user.teamLeader?.email
              ? user.teamLeader.email
              : "",
            teamLeaderId: user.teamLeader?._id,
          };
        });
        return (
          <>
            <Container fluid>
              <Row>
                <Col md="12" style={{ fontSize: "13px" }}>
                  <h4 className="title">App Users</h4>
                  {/* <p className="category">
                        A powerful react plugin handcrafted by our friends from{" "}
                        <a
                          href="https://react-table.tanstack.com/"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          react-table
                        </a>
                        . It is a highly flexible tool, based upon the foundations of
                        progressive enhancement on which you can add advanced interaction
                        controls. Please check out their{" "}
                        <a
                          href="https://react-table.tanstack.com/"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          full documentation.
                        </a>
                      </p> */}
                  <Nav role="tablist" variant="tabs" defaultActiveKey="All">
                    <Nav.Item>
                      <Nav.Link
                        eventKey="All"
                        onClick={() => setSelectedTab(defaultTab)}
                      >
                        All ({tableData?.length})
                      </Nav.Link>
                    </Nav.Item>
                    {map(tabs, (tab) => (
                      <Nav.Item>
                        <Nav.Link
                          eventKey={tab.name}
                          onClick={() => setSelectedTab(tab)}
                        >
                          {tab.name} ({filter(tableData, tab.filter)?.length})
                        </Nav.Link>
                      </Nav.Item>
                    ))}
                  </Nav>
                  <Card>
                    <Card.Body>
                      <ReactTable
                        data={filter(tableData, selectedTab.filter)}
                        columns={tableColumns}
                        footer={BulkFooter}
                        /*
                              You can choose between primary-pagination, info-pagination, success-pagination, warning-pagination, danger-pagination or none - which will make the pagination buttons gray
                            */
                        className="-striped -highlight primary-pagination"
                      />
                    </Card.Body>
                  </Card>
                </Col>
                {/* <Col xs="6" style={{ marginTop: 25, textAlign: "left" }}>
                  <CSVLink
                    data={filter(tableData, selectedTab.filter)}
                    headers={compact(
                      map(tableColumns, (column) => {
                        if (!column.skipCSVDownload)
                          return {
                            label: column.header,
                            key: column.accessorKey,
                          };
                      })
                    )}
                  >
                    Download Users
                  </CSVLink>
                </Col> */}
                <Col xs="6" style={{ marginTop: 25, textAlign: "right" }}>
                  <Button
                    onClick={() => setModal(!modal)}
                    style={{
                      paddingLeft: 20,
                      paddingRight: 20,
                      paddingTop: 15,
                      paddingBottom: 15,
                      fontSize: 16,
                      fontWeight: "bold",
                    }}
                  >
                    Add User
                  </Button>
                </Col>
              </Row>
            </Container>
            <Modal
              className="modal-primary"
              onHide={handleClose}
              show={modal}
              size="md"
            >
              <Modal.Header className="justify-content-center">
                <label>{!editEmail ? "Add User" : "Edit User"}</label>
              </Modal.Header>
              <Modal.Body>
                <Form action="#" method="#">
                  <Form.Group>
                    <label>First Name</label>
                    <Form.Control
                      value={firstName}
                      placeholder="Enter First Name"
                      type="text"
                      onChange={(event) => setFirstName(event.target.value)}
                    />
                  </Form.Group>
                  <Form.Group>
                    <label>Last Name</label>
                    <Form.Control
                      value={lastName}
                      placeholder="Enter Last Name"
                      type="text"
                      onChange={(event) => setLastName(event.target.value)}
                    />
                  </Form.Group>
                  <Form.Group>
                    <label>Email address</label>
                    <Form.Control
                      value={email}
                      placeholder="Enter email"
                      type="email"
                      onChange={(event) => setEmail(event.target.value)}
                    />
                  </Form.Group>
                  {!editEmail && (
                    <Form.Group>
                      <label>Password</label>
                      <InputGroup>
                        <Form.Control
                          placeholder="Password"
                          value={password}
                          onChange={(event) => setPassword(event.target.value)}
                          isInvalid={showError}
                          type={passwordMask ? "password" : "text"}
                        ></Form.Control>
                        <Button
                          variant="secondary"
                          onClick={togglePasswordVisibility}
                          // className={
                          //   passwordMask ? "text-primary" : "text-secondary"
                          // }
                        >
                          {passwordMask ? <EyeSlash /> : <Eye />}
                        </Button>
                        <Form.Control.Feedback type="invalid">
                          {showError}
                        </Form.Control.Feedback>
                      </InputGroup>
                    </Form.Group>
                  )}
                  {editEmail && teamLeaderId !== userId && (
                    <Form.Group controlId="exampleForm.SelectCustom">
                      <Form.Label>Team Leader</Form.Label>
                      <Form.Control
                        as="select"
                        custom
                        value={teamLeaderId}
                        isInvalid={showError}
                        onChange={(event) =>
                          setTeamLeaderId(event.target.value)
                        }
                      >
                        <option value="">No Team Leader</option>
                        {map(
                          filter(tableData, (user) => {
                            return user.teamLeaderId === user._id;
                          }),
                          (user) => (
                            <option value={user._id}>{user.name}</option>
                          )
                        )}
                        {/* Add more options as needed */}
                      </Form.Control>
                      <Form.Control.Feedback type="invalid">
                        {showError}
                      </Form.Control.Feedback>
                    </Form.Group>
                  )}
                  {editEmail && (
                    <Form.Group controlId="exampleForm.SelectCustom">
                      <Form.Label>Challenge</Form.Label>
                      <Form.Control
                        as="select"
                        custom
                        value={challengeId}
                        onChange={handleChallengeChange}
                      >
                        <option value="">No Active Challenge</option>
                        {map(
                          filter(challenges, (challenge) => {
                            return challenge.published;
                          }),
                          (challenge) => (
                            <option value={challenge._id}>
                              {challenge.title}
                            </option>
                          )
                        )}
                        {/* Add more options as needed */}
                      </Form.Control>
                    </Form.Group>
                  )}
                  {editEmail &&
                    props.session.me.clientName === "mendedLight" && (
                      <>
                        <Form.Group>
                          <Form.Label>Course</Form.Label>
                          <Form.Control
                            as="select"
                            custom
                            value={courseId}
                            onChange={handleCourseChange}
                          >
                            <option value="">No Active Course</option>
                            {map(courses, (course) => (
                              <option value={course._id}>{course.title}</option>
                            ))}
                            {/* Add more options as needed */}
                          </Form.Control>
                        </Form.Group>
                      </>
                    )}
                  <b>Subscription</b>
                  {!editEmail || showSubscriptionFields || 1 === 1 ? (
                    <>
                      <Form.Group controlId="exampleForm.SelectCustom">
                        <Form.Label>Active</Form.Label>
                        <Form.Control
                          as="select"
                          custom
                          value={active ? "yes" : "no"}
                          onChange={handleActiveChange}
                        >
                          <option value="yes">Active - External</option>
                          <option value="no">Inactive - External</option>
                          {/* Add more options as needed */}
                        </Form.Control>
                      </Form.Group>

                      <Form.Group controlId="exampleForm.SelectCustom">
                        <Form.Label>Expiration Date</Form.Label>
                        <DatePicker
                          selected={expirationDate}
                          onChange={setExpirationDate}
                          placeholderText="Expiration Date"
                          customInput={
                            <Form.Control
                              style={{
                                borderColor: "black",
                                color: "black",
                                borderWidth: 1,
                                padding: 10,
                                borderRadius: 50,
                                marginBottom: 10,
                              }}
                            ></Form.Control>
                          }
                        />
                      </Form.Group>
                      {
                        // props.session.me.clientName === "feelwise" ||
                        // props.session.me.clientName === "regulate" ||
                        // props.session.me.clientName === "lumify") &&
                        // userId === editTeamLeaderId && (
                        <>
                          <Form.Group>
                            <label>Number of Gifts (including yourself)</label>
                            <Form.Control
                              value={gifts}
                              placeholder="6"
                              type="text"
                              onChange={(event) => setGifts(event.target.value)}
                            />
                          </Form.Group>
                        </>
                      }
                      {editEmail && (
                        <Button
                          className="btn-danger"
                          onClick={handleOpenCancel}
                          variant="outlined"
                          color="primary"
                        >
                          Cancel Subscription
                        </Button>
                      )}
                    </>
                  ) : (
                    <p>
                      This users subscription cannot be edited. The user must
                      cancel their subscription themselves
                    </p>
                  )}
                  <>
                    {
                      //props.session.me.clientName === "feelwise" ||
                      //props.session.me.clientName === "regulate" ||
                      props.session.me.clientName === "lumify" && (
                        // (userId === editTeamLeaderId || isCoach) && (
                        <>
                          <Form.Check className="mb-1 pl-0">
                            <Form.Check.Label>
                              <Form.Check.Input
                                checked={isCoach}
                                type="checkbox"
                                onChange={() => setIsCoach(!isCoach)}
                              ></Form.Check.Input>
                              <span className="form-check-sign"></span>
                              Mark as coach
                            </Form.Check.Label>
                          </Form.Check>
                        </>
                      )
                      //)
                    }
                    <Form.Check className="mb-1 pl-0">
                      <Form.Check.Label>
                        <Form.Check.Input
                          checked={supportPasswordEnabled}
                          type="checkbox"
                          onChange={() =>
                            setSupportPasswordEnabled(!supportPasswordEnabled)
                          }
                        ></Form.Check.Input>
                        <span className="form-check-sign"></span>
                        Enable Support Password Access
                      </Form.Check.Label>
                    </Form.Check>
                  </>
                </Form>
              </Modal.Body>
              <div className="modal-footer">
                <Button
                  className="btn-simple"
                  onClick={handleClose}
                  variant="link"
                >
                  Cancel
                </Button>
                {editEmail && (
                  <Button
                    className="btn-simple"
                    onClick={handleOpenPassword}
                    variant="link"
                  >
                    Reset Password
                  </Button>
                )}
                <Button
                  className="btn-simple"
                  onClick={editEmail ? handleEditUser : handleAddUser}
                  variant="outlined"
                  color="primary"
                  disabled={!email || !(editEmail || password) || !gifts}
                >
                  Save
                </Button>
              </div>
            </Modal>

            <Modal
              className="modal-primary"
              onHide={handleClosePassword}
              show={modalPassword}
              size="md"
            >
              <Modal.Header className="justify-content-center">
                <label>Reset Password</label>
              </Modal.Header>
              <Modal.Body>
                <Form action="#" method="#">
                  <Form.Group>
                    <label>Password</label>
                    <InputGroup>
                      <Form.Control
                        placeholder="Password"
                        value={password}
                        onChange={(event) => setPassword(event.target.value)}
                        type={passwordMask ? "password" : "text"}
                      ></Form.Control>
                      <Button
                        variant="secondary"
                        onClick={togglePasswordVisibility}
                        // className={
                        //   passwordMask ? "text-primary" : "text-secondary"
                        // }
                      >
                        {passwordMask ? <EyeSlash /> : <Eye />}
                      </Button>
                    </InputGroup>
                  </Form.Group>
                  <Form.Group>
                    <label>Confirm Password</label>
                    <InputGroup>
                      <Form.Control
                        placeholder="Password"
                        value={confirmPassword}
                        onChange={(event) =>
                          setConfirmPassword(event.target.value)
                        }
                        isInvalid={showErrorConfirm}
                        type={passwordMaskConfirm ? "password" : "text"}
                      ></Form.Control>
                      <Button
                        variant="secondary"
                        onClick={togglePasswordVisibilityConfirm}
                        // className={
                        //   passwordMaskConfirm
                        //     ? "text-primary"
                        //     : "text-secondary"
                        // }
                      >
                        {passwordMaskConfirm ? <EyeSlash /> : <Eye />}
                      </Button>
                      <Form.Control.Feedback type="invalid">
                        {showErrorConfirm}
                      </Form.Control.Feedback>
                    </InputGroup>
                  </Form.Group>
                  <Form.Check className="mb-1 pl-0">
                    <Form.Check.Label>
                      <Form.Check.Input
                        checked={needPasswordReset}
                        type="checkbox"
                        onChange={() =>
                          setNeedPasswordReset(!needPasswordReset)
                        }
                      ></Form.Check.Input>
                      <span className="form-check-sign"></span>
                      Force user to reset password
                    </Form.Check.Label>
                  </Form.Check>
                </Form>
              </Modal.Body>
              <div className="modal-footer">
                <Button
                  className="btn-simple"
                  onClick={handleClosePassword}
                  variant="link"
                >
                  Cancel
                </Button>
                <Button
                  className="btn-simple"
                  onClick={handleChangePassword}
                  variant="outlined"
                  color="primary"
                  disabled={!password || !confirmPassword}
                >
                  Save
                </Button>
              </div>
            </Modal>

            <Modal
              className="modal-primary"
              onHide={handleCloseDelete}
              show={deleteModal}
              size="md"
            >
              <Modal.Header className="justify-content-center">
                <label>Delete User</label>
              </Modal.Header>
              <Modal.Body>
                Are you sure you want to delete this user? This action cannot be
                undone
              </Modal.Body>
              <div className="modal-footer">
                <Button
                  className="btn-simple"
                  onClick={handleCloseDelete}
                  variant="outlined"
                >
                  Cancel
                </Button>
                <Button
                  className="btn-simple"
                  onClick={handleDeleteUser}
                  variant="danger"
                  color="primary"
                >
                  Delete User
                </Button>
              </div>
            </Modal>

            <Modal
              className="modal-primary"
              onHide={handleCloseCancel}
              show={cancelModal}
              size="md"
            >
              <Modal.Header className="justify-content-center">
                <label>Cancel Subscription</label>
              </Modal.Header>
              <Modal.Body>
                Are you sure you want to cancel this subscription? This action
                cannot be undone
              </Modal.Body>
              <div className="modal-footer">
                <Button
                  className="btn-simple"
                  onClick={handleCloseCancel}
                  variant="outlined"
                >
                  Cancel
                </Button>
                <Button
                  className="btn-simple"
                  onClick={handleCancelSubscription}
                  variant="danger"
                  color="primary"
                >
                  Cancel Subscription
                </Button>
              </div>
            </Modal>

            <Modal
              className="modal-primary"
              onHide={() => setSelectedLeaderId(null)}
              show={selectedLeaderId}
              size="lg"
            >
              <BlockUi
                blocking={loader}
                message={<div className="text-primary">Changing Team</div>}
                tag="modal-primary"
              >
                <Modal.Header className="justify-content-center">
                  <label>
                    {selectedLeader?.firstname + " " + selectedLeader?.lastname}{" "}
                    Team Members
                  </label>{" "}
                </Modal.Header>
                <Modal.Body>
                  <Card>
                    <Card.Body>
                      <ReactTable
                        data={selectedGroupData}
                        columns={groupTableColumns}
                        /*
                              You can choose between primary-pagination, info-pagination, success-pagination, warning-pagination, danger-pagination or none - which will make the pagination buttons gray
                            */
                        className="-striped -highlight primary-pagination"
                      />
                    </Card.Body>
                  </Card>
                </Modal.Body>
                <div className="modal-footer">
                  <Button
                    className="btn-simple"
                    onClick={() => setSelectedLeaderId(null)}
                    variant="outlined"
                  >
                    Close
                  </Button>
                  <Form.Group controlId="exampleForm.SelectCustom">
                    <Form.Label>Select Paid User to Add to Team</Form.Label>
                    <Form.Control
                      as="select"
                      custom
                      value={selectedUserId}
                      onChange={(event) =>
                        setSelectedUserId(event.target.value)
                      }
                    >
                      {map(
                        filter(tableData, (user) => {
                          return (
                            user.isSubscribed &&
                            user.teamLeaderId === user._id &&
                            !user.isCoach &&
                            !user.isUnofficalMember
                          );
                        }),
                        (user) => (
                          <option value={user?._id}>
                            {user?.name} - {user?.email}
                          </option>
                        )
                      )}
                      <option value="">No one selected</option>
                      {/* Add more options as needed */}
                    </Form.Control>
                  </Form.Group>
                  <Button
                    className="btn-simple"
                    onClick={handleAddPaidUser}
                    color="primary"
                    disabled={!selectedUserId}
                  >
                    Add Paid User
                  </Button>
                </div>
              </BlockUi>
            </Modal>
          </>
        );
      }}
    </Query>
  );
}

export default withSession(AppUsers);
